import styled from 'styled-components';

const Space = styled.div`
  padding: 15px 25px;

  border-bottom: 1px solid #efefef;
`;

export default Space;
